/* Пилот: серверный список остаётся доступен независимо от загрузки карты. */
(() => {
  'use strict';

  var root = document.getElementById('landingIntent');
  if (!root) return;
  var button = document.getElementById('landingMapOpen');
  var dialog = document.getElementById('landingMapDialog');
  var close = document.getElementById('landingMapClose');
  var status = document.getElementById('landingMapStatus');
  var loading = document.getElementById('landingMapLoading');
  var mount = document.getElementById('landingMapMount');
  var template = document.getElementById('landingMapTemplate');
  if (!button || !dialog || !close || !status || !loading || !mount || !template || typeof dialog.showModal !== 'function') return;

  var nonce = document.currentScript ? document.currentScript.nonce : '';
  var assets = Object.create(null);
  var pending = null;
  var ready = false;
  var engineLoaded = false;
  var mounted = false;
  var mapStyle = null;
  var savedScroll = null;

  function mapFailed() {
    ready = false;
    loading.hidden = true;
    status.textContent = 'Карта не загрузилась. Подборка доступна ниже — попробуйте открыть карту ещё раз.';
    button.textContent = 'Повторить загрузку карты';
    if (dialog.open) dialog.close();
  }

  dialog.addEventListener('catalogmap:loading', function() {
    ready = false;
    loading.hidden = false;
  });
  dialog.addEventListener('catalogmap:ready', function() {
    ready = true;
    loading.hidden = true;
    status.textContent = '';
    button.textContent = 'Показать на карте';
  });
  dialog.addEventListener('catalogmap:error', mapFailed);

  function loadAsset(src, style) {
    if (assets[src]) return assets[src];
    assets[src] = new Promise(function(resolve, reject) {
      var element = document.createElement(style ? 'link' : 'script');
      var timer = setTimeout(function() { finish(new Error('Время загрузки карты истекло')); }, 15000);
      function finish(error) {
        clearTimeout(timer);
        element.onload = null;
        element.onerror = null;
        if (error) {
          element.remove();
          delete assets[src];
          reject(error);
        } else {
          if (style) element.disabled = !dialog.open;
          resolve();
        }
      }
      if (style) {
        mapStyle = element;
        element.rel = 'stylesheet';
        element.href = src;
      } else {
        element.nonce = nonce;
        element.src = src;
        element.async = false;
      }
      element.onload = function() { finish(); };
      element.onerror = function() { finish(new Error('Не удалось загрузить карту')); };
      document.head.appendChild(element);
    });
    return assets[src];
  }

  function prepareMap() {
    if (pending) return pending;
    loading.hidden = false;
    status.textContent = '';
    if (engineLoaded) {
      dialog.dispatchEvent(new Event('catalogmap:reload'));
      return;
    }
    pending = Promise.all([
      loadAsset(dialog.dataset.mapCss, true),
      loadAsset(dialog.dataset.scopeSrc, false),
      loadAsset(dialog.dataset.apiSrc, false)
    ]).then(function() {
      if (!window.ymaps || typeof window.ymaps.ready !== 'function') {
        delete assets[dialog.dataset.apiSrc];
        throw new Error('Движок карты недоступен');
      }
      if (!mounted) {
        mount.appendChild(template.content.cloneNode(true));
        mounted = true;
      }
      return loadAsset(dialog.dataset.mapSrc, false);
    }).then(function() {
      engineLoaded = true;
    }).catch(mapFailed).finally(function() {
      pending = null;
    });
    return pending;
  }

  button.hidden = false;
  button.addEventListener('click', function() {
    if (window.NvCatalog) {
      if (!window.CatalogSelection || !window.CatalogSelection.ready()
          || (window.NvCatalog.listState && window.NvCatalog.listState())) return;
      ready = false; // Каждый заход получает текущую выдачу страницы.
    }
    if (mapStyle) mapStyle.disabled = false;
    if (!dialog.open) {
      savedScroll = { x: window.scrollX, y: window.scrollY };
      document.documentElement.classList.add('ifs-map-open');
      dialog.showModal();
    }
    document.body.classList.add('ifs-map-open');
    button.setAttribute('aria-expanded', 'true');
    close.focus({ preventScroll: true });
    if (!ready) prepareMap();
    else window.dispatchEvent(new Event('resize'));
  });
  close.addEventListener('click', function() { dialog.close(); });
  dialog.addEventListener('close', function() {
    // Вложенные панели закрываются, пока CSS карты ещё действует; их opener скрывается.
    dialog.dispatchEvent(new Event('catalogmap:close'));
    // Fullscreen CSS каталога не участвует в геометрии серверного списка после закрытия.
    if (mapStyle) mapStyle.disabled = true;
    document.body.classList.remove('ifs-map-open');
    document.documentElement.classList.remove('ifs-map-open');
    button.setAttribute('aria-expanded', 'false');
    button.focus({ preventScroll: true });
    if (savedScroll && (window.scrollX !== savedScroll.x || window.scrollY !== savedScroll.y)) {
      window.scrollTo({ left: savedScroll.x, top: savedScroll.y, behavior: 'instant' });
    }
    savedScroll = null;
  });
})();
